import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import { AppContext } from "../../context/AppContextProvider";
import { useLocation } from "react-router";
import HaqtTenantToggle from "../../components/HaqtTenantToggle";
import HaqtProfileMenu from "../../components/HaqtProfileMenu";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import MenuIcon from "@mui/icons-material/Menu";
import headerLogoImg from "../../assests/img/HEADER.png";
import logoImg from "../../assests/img/logo.png";
import EngineeringIcon from "@mui/icons-material/Engineering";
import headerImg from "../../assests/img/headerImg.png";
import headerBackround from "../../assests/img/headerBackground.jpg";
import AlertNotifications from "../../pages/AlertNotifications/AlertNotifications";
import { useNavigate } from "react-router-dom";
import { getSessionStorageItem } from "../../utils/sessionStorageUtils";

const HaqtAppBar = (props) => {
  const navigate = useNavigate();
  const { drawerWidth, drawerOpen, handleDrawerOpen, handleDrawerClose } =
    props;
  const { user } = useContext(AppContext);
  const userRoleInfo = getSessionStorageItem("haqt_userrole");
  const userRole = userRoleInfo.role;
  const location = useLocation();
  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    width: "100%",
    position: "fixed",
  }));

  //backgroundColor: "#005572"
  return (
    <AppBar
      sx={{
        background: "#fff",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        height: "64px",
      }}
    >
      <Grid container sx={{ height: "100%" }}>
        {/* Sidebar Toggle Button with Black Background */}
        <Grid
          item
          sx={{
            backgroundColor: "black",
            display: "flex",
            alignItems: "center",
          }}
        >
          {location.pathname !== "/admin/maps" && location.pathname !== "/" && (
            <IconButton
              title="Toggle Sidebar"
              aria-label="Toggle Sidebar"
              onClick={drawerOpen ? handleDrawerClose : handleDrawerOpen}
              edge="start"
              sx={{ color: "#fff", ml: 1, paddingRight: "20px" }}
            >
              <MenuIcon sx={{ fontSize: { xs: "24px", sm: "32px" } }} />
            </IconButton>
          )}
        </Grid>

        {/* Rest of the AppBar with Background Image */}
        <Grid
          item
          xs
          sx={{
            background: `url(${headerBackround}) no-repeat center center`,
            // backgroundSize: "cover",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
          }}
        >
          <Typography variant="h6" noWrap component="div">
            <Box
              component="img"
              src={headerLogoImg}
              alt="logo"
              title="Mizu Link"
              sx={{
                //  height: "50px",
                height: { xs: "30px", sm: "50px" },
                width: { xs: "149px", sm: "auto" },
                marginLeft: "16px",
              }}
            />
          </Typography>

          <div style={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ pr: 2 }}>
              {location.pathname !== "/admin/maps" && <HaqtTenantToggle />}
            </Box>

            <Box sx={{ flexGrow: 0, pr: 2, pl: 1 }}>
              {location.pathname == "/admin/maps" &&
                userRole !== "operator" && (
                  <EngineeringIcon
                    className="alert-icon"
                    // Dheeraj Edit - styling
                    sx={{
                      cursor: "pointer",
                      color: "#0A6073",
                      fontSize: "28px",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        color: "#0c7389",
                        transform: "translateY(-2px)",
                      },
                      "&:active": {
                        transform: "translateY(1px)",
                        color: "#084e5d",
                      },
                    }}
                    onClick={() => navigate("/admin/workorder/list")}
                  />
                )}
            </Box>

            <AlertNotifications />

            <Box
              sx={{
                pr: 1,
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                  color: "#0A6073",
                  fontSize: "12px",
                },
                fontWeight: "bold",
              }}
            >
              {user.userName}
            </Box>

            <Box sx={{ flexGrow: 0, pr: 2, pl: 1 }}>
              <HaqtProfileMenu />
            </Box>
          </div>
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default HaqtAppBar;
